<script>
import appConfig from "@/app.config";
import PageList from "../../layouts/page-list";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Partners',
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    PageList
  },
  data() {
    return {
      listFields: [
        {key: "image", sortable: true, label: 'Image'},
        {key: "name", sortable: true, label: 'Nom'},
        {key: "url", sortable: true, label: 'Lien'},
        {key: "created_at", sortable: true, label: this.$t('news.created_at')},
        {key: "updated_at", sortable: true, label: this.$t('news.updated_at')},
        {key: "actions", sortable: false, class: 'text-right', label: " ", tdAttr: {valign: "middle"}},
      ],
      updateListe: false
    }
  },
  methods: {
    displayDate(date) {
      const splitDate = date.replace('T', ' ').split("-");
      const splitTime = splitDate[2].split(' ');

      if (splitTime[1]) {
        return splitTime[0].split() + "/" + splitDate[1] + "/" + splitDate[0] + " " + splitTime[1].split('.')[0];

      }

      return splitTime[0].split() + "/" + splitDate[1] + "/" + splitDate[0];
    }
  }
};
</script>

<template>
  <page-list resource-name="partner" :list-fields="listFields" :update-liste="updateListe" :with-advanced-search="true"
             @updated="updateListe = false">
    <template #cell(image)="data">
      <img :src="'/api/partners/' + data.item.id + '/image'" :alt="data.item.name" height="64px">
    </template>

    <template #cell(url)="data">
      <a :href="data.item.url" target="_blank">{{ data.item.url }}</a>
    </template>

    <template #cell(created_at)="data">
      <span v-if="data.item.created_at">{{ displayDate(data.item.created_at) }}</span>
    </template>

    <template #cell(updated_at)="data">
      <span v-if="data.item.updated_at">{{ displayDate(data.item.updated_at) }}</span>
    </template>
  </page-list>
</template>